import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ChecklistIcon from '@mui/icons-material/Checklist';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { AuthenticatedTemplate } from '@azure/msal-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMyProfileQuery } from '../../../../../services/ProfileService';
import { hasCamEditAccess } from '../../../../profile/utils/profileUtils';
import {
  CLAIMS_QUEUE_PATH,
  CLAIMS_EXCEPTIONS_PATH,
  CLAIMS_MISSED_FINDINGS_PATH,
} from '../../../../claims/routes';

/**
 * "Claims" nav group (spec decision #12) — gated by the **CAM Edit** claim (FR-029 of the spec that
 * introduced the gate; spec 204 FR-012). One expandable group holding Worklist, Exceptions and
 * Missed Findings; the top entry only opens and closes the group and never navigates (spec 204
 * FR-024). The single gate around the list is why the one claim shows all three.
 */
function ClaimsMenu() {
  const navigate = useNavigate();
  const [claimsOpen, setClaimsOpen] = useState(false);
  const { data: profile } = useGetMyProfileQuery();

  const navigateToQueue = () => {
    navigate(CLAIMS_QUEUE_PATH);
  };

  const navigateToExceptions = () => {
    navigate(CLAIMS_EXCEPTIONS_PATH);
  };

  const navigateToMissedFindings = () => {
    navigate(CLAIMS_MISSED_FINDINGS_PATH);
  };

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        {hasCamEditAccess(profile) && (
          <List component="nav" sx={{ border: 'black solid 1px' }}>
            <ListItemButton onClick={() => setClaimsOpen(!claimsOpen)} data-testid="claims-menu-button">
              <ListItemText primary="Claims" />
              {claimsOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={claimsOpen} timeout="auto" unmountOnExit>
              <ListItemButton sx={{ marginTop: '0px' }} onClick={navigateToQueue} data-testid="claims-menu-worklist">
                <ListItemIcon>
                  <ChecklistIcon sx={{ color: 'white' }} />
                </ListItemIcon>
                <ListItemText primary="Worklist" />
              </ListItemButton>
              <ListItemButton sx={{ marginTop: '0px' }} onClick={navigateToExceptions} data-testid="claims-exceptions-menu-button">
                <ListItemIcon>
                  <ReportProblemIcon sx={{ color: 'white' }} />
                </ListItemIcon>
                <ListItemText primary="Exceptions" />
              </ListItemButton>
              <ListItemButton sx={{ marginTop: '0px' }} onClick={navigateToMissedFindings} data-testid="claims-menu-missed-findings">
                <ListItemIcon>
                  <FindInPageIcon sx={{ color: 'white' }} />
                </ListItemIcon>
                <ListItemText primary="Missed Findings" />
              </ListItemButton>
            </Collapse>
          </List>
        )}
      </AuthenticatedTemplate>
    </React.Fragment>
  );
}

export { ClaimsMenu };
